import { render, staticRenderFns } from "./PostalCodeDashboard.vue?vue&type=template&id=1e71c16a"
import script from "./PostalCodeDashboard.vue?vue&type=script&lang=js"
export * from "./PostalCodeDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports